import React, {PropsWithChildren} from 'react';
import styled from 'styled-components';
import {Logo} from '../Admin/Layout';

type SimplePageProps = PropsWithChildren<{}>;

const SimplePage = ({children}: SimplePageProps) => {
  return (
    <>
      <Header>
        <Logo />
      </Header>
      <Page>{children}</Page>
    </>
  );
};

export default SimplePage;

const Header = styled.header`
  display: flex;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 3;
  background-color: #fff;
  padding: 0 15%;
  height: ${(props) => props.theme.layout.simplePagesHeader};
  box-shadow: 0px 0px 12px ${(props) => props.theme.colors.shadow};

  @media ${(props) => props.theme.responsive.tablet} {
    padding: 0 5%;
  }

  > div {
    height: 60%;
    padding: 0;
    margin: 0;
  }
`;

const Page = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: ${(props) => props.theme.layout.simplePagesHeader};

  p,
  ol,
  ul {
    font-family: ${(props) => props.theme.typography.main};
    font-size: 14px;
    line-height: 1.8;
    color: ${(props) => props.theme.colors.bodyText};
    margin: 0 0 16px;
  }

  li {
    margin-bottom: 12px;
  }

  a {
    color: ${(props) => props.theme.colors.main};
  }

  h3 {
    line-height: 1.5;
  }

  .table-wrapper {
    display: block;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }

  table {
    border: 1px solid ${(props) => props.theme.colors.border};
    border-collapse: collapse;

    td {
      padding: 16px;
      vertical-align: top;
      border: 1px solid ${(props) => props.theme.colors.border};
    }
  }
`;
